import { Inject } from '@odinjs/odin';

import { TableAPI } from '@philips-emr/tws-components';
import Controller, { OnClick } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { isEmptyObject } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

@Controller({ fragment: 'locator-procedimento' })
export default class LocatorProcedimentoController extends BaseController {

  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext!: SubmittableFragmentContext;
  @Inject('table')
  private table: TableAPI;

  @OnClick({ target: 'button-selecionar' })
  onClick(): void {
    const [selected] = this.table.getSelectedRows() || [];

    if (!isEmptyObject(selected)) {
      this.submittableFragmentContext.submit(new SubmitEvent({ record: selected }));
    }
  }
}
